import { conferenceTypesEnum } from "./components/ConferenceType/conferenceTypesEnum"
import { intervalTypesEnum } from "./components/IntervalType/intervalTypesEnum"

export const getInitialState = ({profile}) => {
    return (
        {
            name: "",
            speaker_id: profile?.role === "seminarian" ? profile.id : null,//объеденить
            groups: [],
            // material_id: "",
            interval_type: intervalTypesEnum.oneTime,
            date_conference: null, 
            start_date: null,
            end_date: null,
            time: {
                start_time: "12:30",
                end_time: "14:00",
            },
            inRecording: false,
            link_to_meeting: "",
            link_to_meeting_for_children: "",
            direction: null,
            members: [],
            comment: "",
            comment_dz:"",
            course: null,
            isOffline: false,
            audienceNumber: null,
            isChooseMaterial: false,
            materialComment: null,
            lessonType: null,
            directionCourse: null,
            courseMaterial: null,
            topicLesson: null,
            priceViaSchedule: "",
            availableViaSchedule: false,
            scheduleInGoogleCalendar: true,
            conference_type: conferenceTypesEnum.group,
            unavailableStudents: [],
            seminariansСlasses: [],
            customDaysValue: {},
            comment_to_dz: '',
            lesson_topic: '',
            childrens: [],
            tariff: null,
            customizableValue: {}
        }
    )
}